import React, {useCallback, useMemo, useState} from "react";
import RightArrow from "../../assets/image/icon_right_sm.svg";
import ViewIcon from "../../assets/image/icon_eye.svg";
import Split from "../../assets/image/split.svg";
import Playlist from "../../assets/image/playlist-icon.svg"
import Delete from "../../assets/image/icon_trash.svg"
import Send from "../../assets/image/icon_fileplus.svg"
import Setting from "../../assets/image/icon_setting.svg"
import useFetch from "@common/hooks/fetch/useFetch";
import {
  getMyAdWatchViewList,
  getMyAdLikeViewList,
  getAdicPlayList,
  getAdicPlayListAd,
  postAdicPlayList,
  removeAdicPlayList, postAdicApplication
} from '../../../common/services/restapi/mypage'
import {Moments} from "@common/utils/date/moments";
import {Link} from "react-router-dom"
import AdCategory from "@common/enums/AdCategory.enums";
import Sort from "@common/enums/Sort.enums";
import Page from "@common/enums/Page.enums";
import {useAuth} from "@common/contexts/auth/AuthProvider";
import {
  isMobileApp,
} from "@common/utils/app/appUtils";
import {getAdCategoryList, removeAdLikeStatus} from "@common/services/restapi/ad";
import SmallCardHorizontal from "../set/SmallCardHorizontal";
import {Modal} from "react-bootstrap";
import BtnMedium from "../component/BtnMedium";
import {useAsyncFn} from "react-use";
import {Slide, toast, ToastContainer} from "react-toastify";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {convertPath} from "@common/utils/path/linkPath";

/*const AD_CATEGORY_MENU = [AdCategory.tv, AdCategory.print, AdCategory.radio, AdCategory.outdoor, AdCategory.cinema, AdCategory.inet,
  AdCategory.internet, AdCategory.inet, AdCategory.mobile, AdCategory.newtype, AdCategory.foreign];

const SORT_LIST = [Sort.wdate, Sort.acount];*/

function Mypage() {
  const auth = useAuth();
  const {adicUser} = auth;
  const loginSocial = adicUser && adicUser.socialType && auth && auth.socialProvider.find(social => social.enumKey === adicUser.socialType);

  const onLogout = () => {
    auth.signOut().catch((error) => {
      alert(error);
    });
  };

  // 새 재생목록 만들기
  const [inputTitle, setInputTitle] = useState(false);
  const [inputFocus, setInputFocus] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const handleUserInput = (e) => {
    setInputValue(e.target.value);
  }

  const clearUserInput = () => {
    setInputValue("");
  }

  const [postPlaylist, handlePostPlaylist] = useAsyncFn(async (reqBody) => {
    if (!postPlaylist.loading) {
      const result = await postAdicPlayList(reqBody);
      if (result.hasOwnProperty("code")) {
        // 실패 토스트
        isFail();
      } else {
        // 새 플레이리스트 상태 조회
        await refetchPlaylist();
        // 닫기
        setInputTitle(false);
        // 성공 토스트
        isSuccess()
      }
    }
    if (!postPlaylist.loading) {
      await postAdicPlayList(reqBody);
    }
  }, []);

  const isFail = () => toast.error("입력되지 않은 정보가 존재합니다", {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    closeButton: false
  });

  const isSuccess = () => toast.success("저장되었습니다", {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    closeButton: false
  });


  const handleNewPlaylist = async (inputedTitle) => {

    // 새 플레이리스트 서버 등록
    const reqBody = {
      userId: adicUser.userId,
      title: inputedTitle
    };

    await handlePostPlaylist(reqBody);
  };

  const {data: adicPlayList, refetch: refetchPlaylist} = useFetch(() => getAdicPlayList(), [], []);

  // 플레이리스트 삭제
  const [removePlaylist, handleRemovePlaylist] = useAsyncFn(async (reqBody) => {
    if (!removePlaylist.loading) {
      await removeAdicPlayList(reqBody);

      await refetchPlaylist();
    }
  });

  const eachPlaylistIds = useMemo(() => {
    return adicPlayList.map((eachPlaylist) => {
      return eachPlaylist.id;
    });
  }, [adicPlayList])

  // 재생목록 정보
  const {data: adicPlayListAd} = useFetch(() => getAdicPlayListAd({playlistId: [...eachPlaylistIds]}), [eachPlaylistIds], []);

  const eachPlaylistDetailInfo = useMemo(() => {
    const eachPlaylistDetail = [];
    eachPlaylistIds.forEach((eachPlay) => {
      const eachPlaylistAds = adicPlayListAd.filter((eachPlaylist) => {
        return eachPlay === eachPlaylist.playlistId;
      });
      if (eachPlaylistAds.length > 0) {
        eachPlaylistDetail.push({
          id: eachPlaylistAds[0].playlistId,
          totalCount: eachPlaylistAds.length,
          thumbnail: eachPlaylistAds[0].ad.thumbnail
        })
      }
    });
    return eachPlaylistDetail;
  }, [adicPlayListAd])

  return (
    <div className="mypage">
      <div className="header-box">
        <div className="row-box mb-3">
          <h3 className="headline">My Page</h3>
          <a href={convertPath("/mypage/setting")} className="setting-btn">
            {
              isMobileApp() &&
              <img src={Setting} alt=""/>
            }
          </a>
        </div>
        <div className="row-box">
          <div className="left-box">
            {
              loginSocial &&
              <img src={loginSocial.myPageLogo} alt="" className="social-logo"/>
            }
            <div className="email">{adicUser && adicUser.userEmail}</div>
          </div>
          <div className="right-box">
            <button className="logout" onClick={onLogout}>로그아웃</button>
          </div>
        </div>
      </div>
      <div className="body-box">
        <MyAdWatchView/>
        <MyAdLikeView/>
        <section className="playlist">
          <div className="section-header">
            <div className="title">재생목록</div>
            <button className="new-playlist" onClick={() => setInputTitle(true)}>
              <img src={Playlist} alt=""/>
              <span>새 재생목록</span>
            </button>
          </div>
          <div className="section-body">
            <div className="thumbnail-wrap playlist">
              {
                adicPlayList &&
                adicPlayList.map((eachData, i) => {
                  const findPlayDetail = eachPlaylistDetailInfo.find(eachPlayDetail => eachPlayDetail.id === eachData.id);
                  return (
                    <div className="thumbnail-list playlist" key={i}>
                      <a href={convertPath(`/mypage/playlist/${eachData.id}`)} className="left-box" key={`ad-${eachData.id}`}>
                        <div className="thumbnail-card theme">
                          {
                            findPlayDetail && findPlayDetail.thumbnail &&
                            <img src={findPlayDetail.thumbnail.replace('/l/', '/m/')} alt=""/>
                          }
                        </div>
                        <div className="text-box">
                          <h4 className="ad-title">{eachData.title}</h4>
                          <div className="ad-subtitle">광고&nbsp;
                            {
                              findPlayDetail ?
                                <><span>{findPlayDetail.totalCount}</span>개</>
                                :
                                <><span>0</span>개</>
                            }

                          </div>
                        </div>
                      </a>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </section>
        <Modal show={inputTitle} dialogClassName={`filter-modal new-playlist`}>
          <Modal.Body>
            <div className="header-band">
              <h5>재생목록명 입력</h5>
            </div>
            <div className="filter-list">
              <div className={`text-input-wrap playlist-input`}>
                <div className={`text-input-box ${inputFocus ? "focus" : ""}`}>
                  <input
                    type="text"
                    value={inputValue}
                    onChange={handleUserInput}
                    placeholder="재생목록명을 입력하세요"
                    onFocus={() => setInputFocus(true)}
                    onBlur={() => setInputFocus(false)}/>
                  <i className={`right-icon mdi mdi-close-circle`} onClick={clearUserInput}/>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <BtnMedium type="button" color="blue" text="저장" onClick={() => handleNewPlaylist(inputValue)}/>
            <BtnMedium type="button" color="black" text="닫기" onClick={() => setInputTitle(false)}/>
          </Modal.Footer>
        </Modal>
        <ToastContainer
          position="bottom-center"
          autoClose={2000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          transition={Slide}
        />
      </div>
    </div>
  )
}

function MyAdWatchView() {

  const auth = useAuth();
  const {adicUser} = auth;
  /*const [page, setPage] = useState(Page.page.defaultPage);

  const [selectedStats, setSelectedStats] = useState(AD_CATEGORY_MENU[0].enumKey);
  const [selectedSorting, setSelectedSorting] = useState(SORT_LIST[0]);

  const searchQuery = useMemo(() => {
    return {
      category: selectedStats,
      sortField1: selectedSorting.enumKey,
      sortOption1: selectedSorting.descSort,
      pageNumber: page,
      pageSize: Page.size.defaultSize
    }
  },[page, selectedStats, selectedSorting]);

  const {data} = useFetch(() => getAdCategoryList(searchQuery), [searchQuery], {});

  const handleSelectThing = useCallback((selectThing) => {
    setSelectedStats(selectThing.enumKey);
  },[]);*/

  const {data: adWatchList} = useFetch(() => getMyAdWatchViewList({pageNumber: 1, pageSize: 5}), [], {});

  return (
    <section className="my-ad">
      <div className="section-header">
        <div className="title">내가 본 광고</div>
        <a href={convertPath(`/mypage/watched`)} className="detail-view">
          <span>전체보기</span>
          <img src={RightArrow} alt=""/>
        </a>
      </div>
      <div className="section-body">
        <div className="thumbnail-wrap">
          {
            adWatchList && adWatchList.histories && adWatchList.histories.map((adWatch) => {
              const ad = adWatch.ad;
              if (!ad) return null;
              return (
                <a href={convertPath(`/ad/${adWatch.adCategory}/${ad.ukey}`)} className="thumbnail-list small-video"
                   key={`my-ad-watch-${ad.ukey}`}>
                  <div className="thumbnail-card-wrapper">
                    <LazyLoadImage className="thumbnail-card small-video"
                                   src={`${ad.thumbnail.replace('/l/', '/m/').replace("http:", "https:")}`}/>
                  </div>
                  <div className="text-box">
                    <h4 className="ad-title">{ad.title}</h4>
                    <span className="ad-subtitle">{ad.brand}</span>
                    <div className="row-box">
                      <div className="view-count">
                        <img src={ViewIcon} alt=""/>
                        <span>{ad.rcount}</span>
                      </div>
                      <img src={Split} alt=""/>
                      <div className="created-date">{Moments.Format(ad.wdate, 'yyyy.MM.DD')}</div>
                    </div>
                  </div>
                </a>
              )
            })
          }
        </div>
      </div>
    </section>
  )
}

function MyAdLikeView() {

  const auth = useAuth();
  const {adicUser} = auth;
  /*const [page, setPage] = useState(Page.page.defaultPage);

  const [selectedStats, setSelectedStats] = useState(AD_CATEGORY_MENU[0].enumKey);
  const [selectedSorting, setSelectedSorting] = useState(SORT_LIST[0]);

  const searchQuery = useMemo(() => {
    return {
      category: selectedStats,
      sortField1: selectedSorting.enumKey,
      sortOption1: selectedSorting.descSort,
      pageNumber: page,
      pageSize: Page.size.defaultSize
    }
  },[page, selectedStats, selectedSorting]);

  const {data} = useFetch(() => getAdCategoryList(searchQuery), [searchQuery], {});

  const handleSelectThing = useCallback((selectThing) => {
    setSelectedStats(selectThing.enumKey);
  },[]);*/

  const {data: adLikeList} = useFetch(() => getMyAdLikeViewList({pageNumber: 1, pageSize: 5}), [], []);

  return (
    <section className="my-like-ad">
      <div className="section-header">
        <div className="title">내가 좋아하는 광고</div>
        <a href={convertPath(`/mypage/liked`)} className="detail-view">
          <span>전체보기</span>
          <img src={RightArrow} alt=""/>
        </a>
      </div>
      <div className="section-body">
        <div className="thumbnail-wrap">
          {
            adLikeList.map((adLike) => {
              const ad = adLike.ad;
              if (!ad) return null;
              return (
                <a href={convertPath(`/ad/${adLike.adCategory}/${ad.ukey}`)} className="thumbnail-list small-video"
                   key={`my-ad-watch-${ad.ukey}`}>
                  <div className="thumbnail-card-wrapper">
                    <LazyLoadImage className="thumbnail-card small-video"
                                   src={`${ad.thumbnail.replace('/l/', '/m/').replace("http:", "https:")}`}/>
                  </div>
                  <div className="text-box">
                    <h4 className="ad-title">{ad.title}</h4>
                    <span className="ad-subtitle">{ad.brand}</span>
                    <div className="row-box">
                      <div className="view-count">
                        <img src={ViewIcon} alt=""/>
                        <span>{ad.rcount}</span>
                      </div>
                      <img src={Split} alt=""/>
                      <div className="created-date">{Moments.Format(ad.wdate, 'yyyy.MM.DD')}</div>
                    </div>
                  </div>
                </a>
              )
            })
          }
        </div>
      </div>
    </section>
  )
}

export default Mypage;
